import './Presentacion.css';

export default function Presentacion() {
  return (
     <section className="Invitacion-Presentacion">
        <div>
          <p><span className="block-left circle-trans">Boda de Carlos & Solyenitzi</span></p>
          <p><span className="block-left title-mega">CARLOS</span></p>
          <p><span className="block-left title-mega">& SOLYENITZI</span></p>
          <p><span className="block-rigth circle-trans ">28/NOV/2026</span></p>
        </div>
      </section>
  )
}
